<script setup lang="ts">
import AppLogo from './AppLogo.vue';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();

const menu = ref(null);

function navigateToPrecon() {
    window.location.href = '/';
}

const mailToAddress = 'info@precon.group';
</script>

<template>
    <div :class="'h-screen  md:h-auto ' + 'landing-wrapper'">
        <div
            class="flex align-items-center justify-content-between relative py-6 mx-0 px-4 lg:py-6"
        >
            <a class="cursor-pointer" @click="navigateToPrecon()">
                <AppLogo height="3em" full />
            </a>
            <a
                v-ripple
                v-styleclass="{
                    selector: '@next',
                    enterClass: 'hidden',
                    enterActiveClass: 'px-fadein',
                    leaveToClass: 'hidden',
                    leaveActiveClass: 'px-fadeout',
                    hideOnOutsideClick: 'true',
                }"
                class="cursor-pointer block md:hidden text-700 text-primary"
            >
                <i class="pi pi-bars text-4xl"></i>
            </a>

            <ul
                ref="menu"
                style="top: 0px; right: 0%"
                class="list-none flex-grow-1 justify-content-end hidden md:flex absolute md:relative h-screen md:h-auto surface-card md:surface-ground m-0 z-5 w-full sm:w-6 md:w-full py-6 md:py-0"
            >
                <a
                    v-ripple
                    v-styleclass="{
                        selector: '@parent',
                        enterClass: 'hidden',
                        enterActiveClass: 'px-scalein',
                        leaveToClass: 'hidden',
                        leaveActiveClass: 'px-fadeout',
                    }"
                    class="cursor-pointer block md:hidden text-700 text-primary absolute"
                    style="top: 3rem; right: 2rem"
                >
                    <i class="pi pi-times text-4xl"></i>
                </a>
                <!--
                <li class="flex align-items-center">
                    <Button
                        v-ripple
                        v-styleclass="{
                            selector: '@grandparent',
                            enterClass: 'hidden',
                            leaveToClass: 'hidden',
                        }"
                        type="button"
                        :label="t('go-to-gino')"
                        class="m-0 mt-3 md:mt-0 ml-3 md:ml-5 text-white bg-orange-500 landing"
                        raised
                        @click="navigateToDashboard"
                    ></Button>
                </li> -->
            </ul>
        </div>
        <router-view></router-view>
        <div class="landing-section px-4 md:px-8 pt-8 mt-8">
            <div class="pt-8 pb-6">
                <div
                    class="flex flex-wrap align-items-center justify-content-between mt-6"
                >
                    <div
                        class="flex align-items-center justify-content-start md:mb-0 mb-3"
                    >
                        <a class="cursor-pointer" @click="navigateToPrecon()">
                            <AppLogo height="3em" full />
                        </a>
                    </div>
                    <div
                        class="flex align-items-center justify-content-between md:mb-0 mb-3"
                    >
                        <a
                            class="text-700 cursor-pointer md:ml-5 ml-2 hover:text-orange-500 transition-duration-200"
                            >{{ t('footer1') }}</a
                        >
                        <a
                            class="text-700 cursor-pointer md:ml-5 ml-2 hover:text-orange-500 transition-duration-200"
                            >{{ t('footer2') }}</a
                        >
                        <a
                            class="text-700 cursor-pointer md:ml-5 ml-2 hover:text-orange-500 transition-duration-200"
                            >{{ t('footer3') }}</a
                        >
                    </div>
                    <div
                        class="flex align-items-center justify-content-between"
                    >
                        <a
                            class="cursor-pointer text-500 md:ml-3 ml-2 hover:text-orange-500 transition-duration-200"
                            href="https://www.linkedin.com/company/precongroup/"
                        >
                            <i class="pi pi-linkedin text-xl"></i>
                        </a>
                        <a
                            class="cursor-pointer text-500 md:ml-3 ml-2 hover:text-orange-500 transition-duration-200"
                            href="https://www.youtube.com/channel/UCEYetgwJYMA99lCT9FgJJ4g"
                        >
                            <i class="pi pi-youtube text-xl"></i>
                        </a>
                        <a
                            class="cursor-pointer text-500 md:ml-3 ml-2 hover:text-orange-500 transition-duration-200"
                            href="mailto:info@precon.group"
                        >
                            <i class="pi pi-envelope text-xl mr-2"></i>
                            <span class="landing">{{ mailToAddress }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
.logo {
    margin-top: 3.5rem;
    margin-left: 10rem;
    position: absolute;
}

.landing-wrapper {
    max-width: 1504px;
    margin-left: auto !important;
    margin-right: auto !important;
}

@media screen and (max-width: 991px) {
    .landing-wrapper .landing-banner {
        height: auto !important;
        margin-bottom: 8rem;
    }
}

.p-button.landing {
    background: var(--orange-500);
    border-color: var(--orange-500);
    border: 1px solid var(--orange-500);
}

.p-button.landing:enabled:hover,
.p-button.landing:hover {
    background: var(--orange-400);
    color: var(--orange-400);
    border-color: var(--orange-400);
}

a.landing > span:hover,
span.landing:hover {
    color: var(--orange-300) !important;
}
</style>

<i18n>
    {
        "en": {
            "footer1": "Brand Policy",
            "footer2": "Privacy Policy",
            "footer3": "Terms of Service",
        },
        "nl": {
            "footer1": "Merkbeleid",
            "footer2": "Privacybeleid",
            "footer3": "Servicevoorwaarden",
        },
        "fr": {
            "footer1": "Politique de marque",
            "footer2": "Politique de confidentialité",
            "footer3": "Conditions de service",
        }
    }
</i18n>
